import { render, staticRenderFns } from "./businessVisited.vue?vue&type=template&id=2d1ca69d&scoped=true"
import script from "./businessVisited.vue?vue&type=script&lang=js"
export * from "./businessVisited.vue?vue&type=script&lang=js"
import style0 from "./businessVisited.vue?vue&type=style&index=0&id=2d1ca69d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1ca69d",
  null
  
)

export default component.exports